import { memo } from 'react';

import { Star, StarFilled } from '@air/next-icons';
import { IconButton, type IconButtonProps } from '@air/primitive-icon-button';
import { Tooltip } from '@air/primitive-tooltip';

export type FavoriteButtonProps = Pick<IconButtonProps, 'onClick'> & {
  bookmarked: boolean;
  disabled?: boolean;
};

export const FavoriteButton = memo(({ bookmarked, onClick, disabled }: FavoriteButtonProps) => (
  <Tooltip label={bookmarked ? 'Unfavorite' : 'Favorite'}>
    <IconButton
      label={bookmarked ? 'Unfavorite' : 'Favorite'}
      appearance="ghost"
      color="grey"
      className="ui2:rounded-4 text-grey-1 hover:text-grey-10 active:text-grey-9"
      onClick={onClick}
      disabled={disabled}
      size="small"
    >
      {bookmarked ? <StarFilled className="size-4" /> : <Star className="size-4" />}
    </IconButton>
  </Tooltip>
));

FavoriteButton.displayName = 'FavoriteButton';
